import { getValue } from '@/helpers/GetValueHelper';

import { THttpService, THttpServiceConfig } from './HttpService';

export const HttpServiceFetch = ({ baseURL }: THttpServiceConfig) => {
  return {
    get: async (url: string, config?: THttpServiceConfig) => {
      try {
        const customConfig = {
          method: 'GET',
          headers: getValue(config, 'headers', {}),
        } as any;

        const credentials = getValue(config, 'credentials', '');
        if (credentials) {
          customConfig.credentials = credentials;
        }

        const result = await fetch(`${baseURL}${url}`, customConfig);
        return await result.json();
      } catch (error) {
        console.log('error', error);
        return error;
      }
    },
    post: async (url: string, data?: any, config?: THttpServiceConfig) => {
      return '';
    },
  } as THttpService;
};
